export enum ProfilePages {
  details = 'details',
  transactions = 'transactions',
  avTest = 'avTest',
  podcast = 'podcast',
  settings = 'settings',
  promotions = 'promotions',
  viewFeatureFlags = 'viewFeatureFlags',
  ltiSettings = 'ltiSettings',
}
